import { render, staticRenderFns } from "./df-page-store.vue?vue&type=template&id=d5051252"
import script from "./df-page-store.ts?vue&type=script&lang=js&external"
export * from "./df-page-store.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports